import styles from "./ResultsGrid.module.css";
import { Table } from "react-bootstrap";
import Excel from "./excel/Excel";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Input from "../../shared/ui/input/Input";
import NoData from "../../shared/ui/no-data/NoData";

function ResultsGrid() {
  const columns = [
    "Policy Number",
    "Agency Code",
    "Sent Date",
    "Expiration Date",
    "Envelope Status",
    "Insured Delivery Address",
    "Insured Name",
    "Insured Signature Status",
    "Agent Name",
    "Agent Signature Status",
  ];
  const expiredID = "2";
  const expiringSoonID = "4";

  let [rows, setRows] = useState([]);
  let [searchRows, setSearchRows] = useState(rows);
  let [mappedRows, setMappedRows] = useState([]);
  let [search, setSearch] = useState(false);
  let [selectedPolicy, setSelectedPolicy] = useState();

  let AYSUrl = process.env.REACT_APP_AYS_URL;
  let statuses = useSelector((state) => state.esignature.statuses);
  let envelopes = useSelector((state) => state.esignature.envelopes);

  const numberShown = 20;
  let [upTo, setUpTo] = useState(numberShown);

  const convertIdToName = (ID) => {
    return statuses.find((status) => status.Id === ID).Name;
  };

  const handleSearch = (event) => {
    if (event.target.value === "") {
      setSearch(false);
      setSearchRows(rows);
    } else {
      setSearch(true);
      setSearchRows(
        rows.filter(
          (i) =>
            i[6].toUpperCase().includes(event.target.value.toUpperCase()) ||
            i[0].startsWith(event.target.value)
        )
      );
      //InsuredName is the seventh item in the array of each row, PolicyNumber is the first item in the array of each row
    }
  };

  const onForwardArrow = () => {
    if ((!search && rows[upTo]) || (search && searchRows[upTo])) {
      setUpTo(upTo + numberShown);
    }
  };
  const onBackArrow = () => {
    if (
      (!search && rows[upTo - numberShown]) ||
      (search && searchRows[upTo - numberShown])
    ) {
      setUpTo(upTo - numberShown);
    } else {
      setUpTo(numberShown);
    }
  };

  const jumpToPolicySystem = (event, policyNumber) => {
    event.preventDefault();
    setSelectedPolicy(policyNumber);
  };

  const mapRows = (rows) => {
    return rows.map((row, index) => {
      if (index >= upTo - numberShown && index < upTo) {
        //only map the page that are on
        return (
          <tr key={index}>
            {row.map((item, i) => {
              return i !== 0 ? (
                <td key={i}>{item}</td>
              ) : (
                <td key={i}>
                  <a
                    className={styles.viewLink}
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(event) => jumpToPolicySystem(event, item)}
                  >
                    {item}
                  </a>
                </td>
              );
            })}
          </tr>
        );
      }
    });
  }; //PolicyNumber is the first item in the array of each row and it has a link

  useEffect(() => {}, [upTo]); //to force re-render

  useEffect(() => {
    setRows(
      envelopes
        .map((envelope) => {
          return {
            ...envelope,
            EnvelopeStatus:
              envelope.EnvelopeStatus === expiredID &&
              Math.min(envelope.AgentStatus, envelope.InsuredStatus) >=
                parseInt(expiredID)
                ? envelope.EnvelopeStatus
                : Math.min(envelope.AgentStatus, envelope.InsuredStatus), //Expired remains the status even if neither agent nor insured status is expired, other statuses are overriden (except failed delivery which is 1)
            InsuredStatus:
              envelope.EnvelopeStatus === expiredID &&
              envelope.InsuredStatus === expiringSoonID
                ? envelope.EnvelopeStatus
                : envelope.InsuredStatus, //expired overrides expiring soon for insured status
            AgentStatus:
              envelope.EnvelopeStatus === expiredID &&
              envelope.AgentStatus === expiringSoonID
                ? envelope.EnvelopeStatus
                : envelope.AgentStatus,
          };
        }) //expired overrides expiring soon for agent status
        .sort((a, b) => a.EnvelopeStatus - b.EnvelopeStatus)
        .map((envelope) => {
          return [
            envelope.PolicyNumber,
            envelope.AgencyCode,
            envelope.SentDate,
            envelope.ExpirationDate,
            convertIdToName(envelope.EnvelopeStatus.toString()),
            envelope.InsuredEmailOrPhone,
            envelope.InsuredName,
            convertIdToName(envelope.InsuredStatus),
            envelope.AgentName,
            convertIdToName(envelope.AgentStatus),
          ];
        })
    );
    setUpTo(numberShown);
  }, [envelopes]);

  useEffect(() => {
    if (searchRows?.length > 0) {
      setMappedRows(mapRows(searchRows));
    } else if (rows?.length > 0) {
      setMappedRows(mapRows(rows));
    }
  }, [searchRows, rows, upTo]);

  useEffect(() => {}, [mappedRows]); //to force re-render

  useEffect(() => {
    if (selectedPolicy) {
      document.getElementById("policyForm").submit();
    }
  }, [selectedPolicy]);

  return (
    <div className={styles.container}>
      {
        <>
          <div className={styles.excelRow}>
            <Excel columns={columns} rows={rows} title="Envelope Statuses" />
          </div>
          <form
            action={`${AYSUrl}/ays/PolicyChange/Index`}
            className={styles.hiddenForm}
            method="GET"
            id="policyForm"
          >
            <input name="pnum" value={selectedPolicy} />
          </form>
        </>
      }
      {
        <div className={styles.searchRow}>
          <Input width="50%">
            <input
              placeholder="Search Policy Number or Insured Name"
              onChange={(e) => handleSearch(e)}
            />
          </Input>
          {(!search || searchRows?.length > 0) && (
            <div className={styles.pagination}>
              <span>{upTo - numberShown + 1} </span>
              to{" "}
              <span>
                {upTo < mappedRows?.length ? upTo : mappedRows?.length}{" "}
              </span>
              of{" "}
              <span>
                {searchRows?.length > 0 ? searchRows.length : rows?.length}
              </span>
              <button
                onClick={onBackArrow}
                disabled={upTo <= numberShown}
                className={styles.arrowButton}
              >
                {"<"}
              </button>
              <button
                onClick={onForwardArrow}
                disabled={
                  search ? upTo >= searchRows?.length : upTo >= rows.length
                }
                className={styles.arrowButton}
              >
                {">"}
              </button>
            </div>
          )}
        </div>
      }
      {!search || searchRows?.length > 0 ? (
        <Table striped borderless>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th className={styles.headerCell} key={index}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{mappedRows}</tbody>
        </Table>
      ) : (
        <div className={styles.NoDataWrapper}>
          <NoData message="No Results Match Your Search" height="30%" />
        </div>
      )}
    </div>
  );
}

export default ResultsGrid;
